import { render, staticRenderFns } from "./BusinessActivationView.vue?vue&type=template&id=37066c16"
import script from "./BusinessActivationView.vue?vue&type=script&lang=js"
export * from "./BusinessActivationView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports